var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.5 4h-1V2h-2v2h-8V2h-2v2h-1c-1.11 0-1.99.9-1.99 2L3.5 20a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 16h-14V10h14zm0-12h-14V6h14zm-5 5h-4v4h4z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNMTkuNSA0aC0xVjJoLTJ2MmgtOFYyaC0ydjJoLTFjLTEuMTEgMC0xLjk5LjktMS45OSAyTDMuNSAyMGEyIDIgMCAwIDAgMiAyaDE0YzEuMSAwIDItLjkgMi0yVjZjMC0xLjEtLjktMi0yLTJtMCAxNmgtMTRWMTBoMTR6bTAtMTJoLTE0VjZoMTR6bS01IDVoLTR2NGg0eiIvPjwvc3ZnPg==";
export { SvgCalendar1 as ReactComponent };